import React from 'react';

export default function error(props) {
	return (
		<span style={{ marginTop: '5px' }} className="error">
			{props.text}
		</span>
	);
}
